(function () {
  if (customElements.get('shipping-protection-toggle')) return;
  class ShippingProtectionToggle extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.onToggle);
    }
    async onToggle(event) {
      const checkbox = event.target;
      if (!(checkbox instanceof HTMLInputElement)) return;
      checkbox.disabled = true;
      const variantId = this.dataset.variantId;
      try {
        if (checkbox.checked) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
          });
        } else {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 0 }),
          });
        }
        const cart = await (await fetch('/cart.js')).json();
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'shipping-protection',
              data: { source: 'shipping-protection', itemCount: cart.item_count },
            },
          })
        );
      } catch (error) {
        console.error('shipping-protection', error);
        checkbox.checked = !checkbox.checked;
        checkbox.disabled = false;
      }
    }
  }
  customElements.define('shipping-protection-toggle', ShippingProtectionToggle);
})();
